import { Entity, Key } from '@briebug/ngrx-auto-entity';

@Entity({ modelName: 'JobNoBoxReason' })
export class JobNoBoxReason {
  @Key id?: string;
  jobPlan: string;
  employee: string;
  reason: string;
  created?: string;
}
